export const LEVELS = {
  INDUSTRY: '行业服务商',
  PROVINCE: '省代',
  CITY: '城市合伙人',
  DISTRICT: '区县代理',
  ECO: '生态伙伴'
}

export const CHILD_LEVEL = {
  INDUSTRY: 'PROVINCE',
  PROVINCE: 'CITY',
  CITY: 'DISTRICT'
}

const STATUS = {
  PENDING: '待审核',
  APPROVED: '已通过',
  REJECTED: '已驳回',
  PENDING_PAY: '待确认到账',
  PENDING_REVIEW: '待审批',
  UNUSED: '未使用',
  USED: '已使用',
  EXPIRED: '已过期',
  PENDING_CONFIRM: '待确认',
  CONFIRMED: '已确认',
  DISPUTED: '有异议',
  REVIEWED: '待上传发票',
  INVOICED: '待核验',
  VERIFIED: '待打款',
  PAID: '已打款',
  DONE: '已完成',
  PENDING_INVOICE: '待开票',
  INVOICED: '已上传发票',
  PROTECTED: '保护期中',
  SIGNED: '已签署',
  PURCHASE: '购买',
  APPLY: '向总部申请',
  GRANT: '总部下发'
}

export function levelName(code) {
  return LEVELS[code] || code || '—'
}

export function statusName(code) {
  return STATUS[code] || code || '—'
}

export function yuan(value) {
  const n = Number(value || 0)
  return n.toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
}

export function discountText(value) {
  if (value === null || value === undefined || value === '') return '无进货折扣'
  const n = Number(value)
  if (Number.isNaN(n)) return String(value)
  return (n * 10).toFixed(1).replace(/\.0$/, '') + ' 折'
}
